import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import RadioGroup from "../RadioGroup";
import thanas from "../../assets/data/thana.json";
import "./emergency.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

const CorporateRequestPopUp = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    type: "emergency",
    client_name: "",
    phone_number: "",
    company_type: "Insurance Companies",
    number_of_employees: "",
    name_of_md: "",
    phone_of_md: "",
    agreement: true,
  });

  const [makeVisible, setMakeVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (
      formData.client_name &&
      formData.phone_number &&
      formData.company_type &&
      formData.number_of_employees &&
      formData.name_of_md &&
      formData.phone_of_md
    ) {
      setMakeVisible(true);
    } else setMakeVisible(false);
  }, [
    formData.client_name,
    formData.phone_number,
    formData.company_type,
    formData.number_of_employees,
    formData.name_of_md,
    formData.phone_of_md,
  ]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else if (name === "agreement") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: !formData.agreement,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleClick = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const postData = {
      type: "corporate_client",
      category: formData.company_type,
      title: formData.client_name,
      phone_number: formData.phone_number,
      form_data: {
        number_of_employees: formData.number_of_employees,
        type_of_ownership: formData.type_of_ownership,
        name_of_md: formData.name_of_md,
        phone_of_md: formData.phone_of_md,
        agreement: formData.agreement,
      },
    };
    setLoading(true);
    try {
      const req = scAxiosAdmin
        .post("/form_submission", postData, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            toast.success(
              "Your request is received, you will be notified soon!"
            );
            setLoading(false);
          } else {
            toast.error("Ops something went wrong!");
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const bloodGroup = [
    {
      type: "Positive",
      options: [
        { label: "A+", value: "A+" },
        { label: "AB+", value: "AB+" },
        { label: "B+", value: "B+" },
        { label: "O+", value: "O+" },
      ],
    },
    {
      type: "Negative",
      options: [
        { label: "A-", value: "A-" },
        { label: "AB-", value: "AB-" },
        { label: "B-", value: "B-" },
        { label: "O-", value: "O-" },
      ],
    },
  ];

  const positiveBloodTypes = bloodGroup.find(
    (group) => group.type === "Positive"
  ).options;

  const negativeBloodTypes = bloodGroup.find(
    (group) => group.type === "Negative"
  ).options;

  const gender = [
    { label: "Male (M)", value: "Male" },
    { label: "Female (F)", value: "Female" },
  ];

  const ambulance = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  return (
    <div>
      <div
        className={`offcanvas offcanvas-end`}
        tabIndex="-1"
        id="corporateRequestOffcanvasRight"
        aria-labelledby="corporateRequestOffcanvasRightLabel"
        style={{ minWidth: "30%", zIndex: 99999999999999 }}
      >
        <div className="offcanvas-header" style={{ paddingTop: "5rem" }}>
          <div className="ps-3">
            <h4 style={{ color: "#af9763" }}>
              Request for Corporate Agreement
            </h4>
          </div>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </div>

        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              {/* <label htmlFor="client_name">Corporate Client Name:</label> */}
              <input
                type="text"
                className="form-control"
                id="client_name"
                placeholder="Name of the Company..."
                name="client_name"
                value={formData.client_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              {/* <label htmlFor="number_of_employees">Number of Employees:</label> */}
              <input
                type="number"
                className="form-control"
                id="phone_number"
                name="phone_number"
                placeholder="Key Contact..."
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              {/* <label htmlFor="number_of_employees">Number of Employees:</label> */}
              <input
                type="number"
                className="form-control"
                id="number_of_employees"
                name="number_of_employees"
                placeholder="Number of Employees..."
                value={formData.number_of_employees}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              {/* <label htmlFor="company_type">Type of Ownership:</label> */}
              <select
                className="form-control"
                id="company_type"
                name="company_type"
                value={formData.company_type}
                onChange={handleChange}
                required
              >
                <option selected={true} disabled>
                  Type of Ownership
                </option>
                {[
                  "Insurance Companies",
                  "Multinational Companies",
                  "Embassies",
                  "Other Companies",
                ].map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="form-group">
              <input
                type="text"
                className="form-control"
                id="type_of_ownership"
                name="type_of_ownership"
                placeholder="Type of Ownership..."
                value={formData.type_of_ownership}
                onChange={handleChange}
                required
              />
            </div> */}
            <div className="form-group">
              {/* <label htmlFor="name_of_md">
                Name of the CEO/MD/Chairperson:
              </label> */}
              <input
                type="text"
                className="form-control"
                id="name_of_md"
                name="name_of_md"
                placeholder="Name of the CEO/MD/Chairperson..."
                value={formData.name_of_md}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              {/* <label htmlFor="phone_of_md">
                Contact number of the CEO/MD/Chairperson:
              </label> */}
              <input
                type="number"
                className="form-control"
                id="phone_of_md"
                name="phone_of_md"
                placeholder="Contact number of the CEO/MD/Chairperson..."
                value={formData.phone_of_md}
                onChange={handleChange}
                required
              />
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="agreement"
                name="agreement"
                onChange={handleChange}
                defaultChecked
              />
              <label class="form-check-label" for="flexCheckChecked">
                Yes, we agree to perform at least 50 health screening annually
                to encourage preventive healthcare among our employees
              </label>
            </div>
            <button
              disabled={!makeVisible}
              type="submit"
              style={{
                backgroundColor: makeVisible ? "rgb(12, 128, 125)" : "#41414b",
              }}
              className="w-100 btn-primary p-2 rounded-3 border-0  d-flex justify-content-center align-items-center gap-4"
            >
              {loading && (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )}
              <span>Submit</span>
            </button>
          </form>
        </div>
      </div>

      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CorporateRequestPopUp;



// WEBPACK FOOTER //
// ./src/component/frontend/CorporateRequestPopUp.js